export class FileDownloader {
    static downloadFile(file: File, fileName?: string) {
        FileDownloader.downloadBlob(file, fileName || file.name)
    }

    static downloadBlob(blob: Blob, fileName: string) {
        const url = URL.createObjectURL(blob)

        FileDownloader.download(url, fileName)
        URL.revokeObjectURL(url)
    }

    static download(url: string, fileName?: string) {
        const anchor = document.createElement('a')
        anchor.href = url

        if (fileName) {
            anchor.download = fileName
        }

        anchor.click()
    }
}



// WEBPACK FOOTER //
// ./src/app/extratos/shared/file-downloader.ts